import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { OperationalReport, ReportPort } from '../domain/operational-report'

const pbReports: ReportPort = {
	getOperationalReport: async (): Promise<OperationalReport> => {
		const result = await tryCatch(pb.send<OperationalReport>('/api/reports/operations', { method: 'GET', requestKey: null }))
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
	},
}

export { pbReports }
